export default {
  readMore: {
    is: 'Lesa meira',
    en: 'More',
  },
  readLess: {
    is: 'Lesa minna',
    en: 'Less',
  },
};
